module.exports = __webpack_public_path__ + "img/0_3.bfcfe4ce.png";